export default __webpack_public_path__ + "../img/1b396a8df204c10cb5ed501ba4b393f9.png";